module.exports = __webpack_public_path__ + "assets/language-squares/es-419-5f4ab8d83b84d5f90c865c0b0725b011.jpg";